<template>
  <div class="page-container">
    <md-app md-mode="reveal">
      <md-app-toolbar class="md-primary">
        <Header :menuVisible="menuVisible" v-on:toggleMenu="toggleMenu"/>
      </md-app-toolbar>

      <md-app-drawer :md-active.sync="menuVisible">
        <Menu :menuVisible="menuVisible"/>
      </md-app-drawer>

      <md-app-content>
        <div>
            <md-dialog-confirm
                :md-active.sync="deleteConfirm"
                md-title="Confirmación"
                md-content="¿Desea elminar esta Búsqueda?"
                md-confirm-text="Borrar"
                md-cancel-text="Cancelar"
                @md-cancel="deleteConfirm = false"
                @md-confirm="onDeleteConfirm" />

            <md-content v-if="showDialog">
                <form novalidate class="md-layout" @submit.prevent="validateItem">
                <md-card class="md-layout-item">
                    <md-card-header>
                    <div class="md-title" v-if="!formForEdit">Nueva Búsqueda "Quest"</div>
                    <div class="md-title" v-if="formForEdit">Modificar Búsqueda "Quest"</div>
                    </md-card-header>

                    <md-card-content>
                        <md-field>
                            <label for="name">Nombre</label>
                            <md-input name="name" id="name" v-model="form.name" :disabled="sending" />
                        </md-field>

                        <md-field>
                            <label for="name">Descripción</label>
                            <md-input name="description" id="description" v-model="form.description" :disabled="sending" />
                        </md-field>

                        <md-field>
                            <label for="status">Estado</label>
                            <md-select name="status" id="status" v-model="form.status">
                                <md-option value="revision" :disabled="!acl.createsQuests && !acl.modifiesQuests">En revisión</md-option>
                                <md-option value="active" :disabled="!acl.aprovesQuests">Activo</md-option>
                                <md-option value="suspended" :disabled="!acl.suspendsQuests">Suspendido</md-option>
                            </md-select>
                        </md-field>

                        <br />
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item">
                                <gmap-map
                                    :center="center"
                                    :zoom="15"
                                    map-type-id="terrain"
                                    style="width: 100%; height: 300px;"
                                    @center_changed="updateCenter"
                                    @idle="sync">
                                    <gmap-marker
                                        :position="center"
                                        :clickable="false"
                                        :draggable="false">
                                    </gmap-marker>
                                    <gmap-circle
                                        :center="center"
                                        :clickable="false"
                                        :draggable="false"
                                        :options="radiusOptions"
                                        :radius="radius">
                                    </gmap-circle>
                                </gmap-map>
                            </div>
                            <div class="md-layout-item">
                                <md-field>
                                    <label for="name">Latitud</label>
                                    <md-input name="lat" id="lat" v-model="form.lat" :disabled="true" />
                                </md-field>
                                <md-field>
                                    <label for="name">Longitud</label>
                                    <md-input name="lng" id="lng" v-model="form.lng" :disabled="true" />
                                </md-field>
                                <md-field>
                                    <label for="name">Radio de acción (en metros)</label>
                                    <md-input name="radius" id="radius" v-model="form.radius" :disabled="sending" @change="changeRadius(form.radius)"/>
                                </md-field>
                            </div>
                        </div><br />

                    </md-card-content>

                    <md-progress-bar md-mode="indeterminate" v-if="sending" />

                    <md-card-actions>
                    <md-button class="md-accent" @click="cancelForm()">Cancelar</md-button>
                    <md-button type="submit" class="md-primary" :disabled="sending">Guardar</md-button>
                    </md-card-actions>
                </md-card>

                </form>
            </md-content>

            <md-table v-model="quests" md-sort="name" md-sort-order="asc" v-if="!showDialog" md-card md-fixed-header>
                <md-table-toolbar>
                    <h1 class="md-title">Búsquedas "Quests"</h1>
                    <md-button class="md-fab md-primary" @click="showForm()" v-if="acl.createsQuests && !loading">
                        <md-icon>add</md-icon>
                    </md-button>

                    <md-content class="text-xs-center" v-if="loading">
                        <p class="md-subheading md-layout md-alignment-top-center" v-bind:style="{ width: '100%' }">Cargando...</p>
                    </md-content>
                </md-table-toolbar>

                <md-table-row slot="md-table-row" slot-scope="{ item }" v-if="!loading">
                    <md-table-cell md-label="Nombre" md-sort-by="name">{{ item.name }}</md-table-cell>
                    <md-table-cell md-label="Preguntas" md-sort-by="questions.length">{{ item.questions.length }}</md-table-cell>
                    <md-table-cell md-label="Estado" md-sort-by="qtyQuestions">{{ (item.status == 'active') ? 'Activo' : (item.status == 'revision') ? 'En Revisión' : 'Suspendido' }}</md-table-cell>
                    <md-table-cell class="actions-cell">
                        <md-button class="md-icon-button md-primary" @click="editItem(item)" v-if="acl.modifiesQuests">
                            <md-icon>edit</md-icon>
                        </md-button>
                        <md-button class="md-icon-button md-accent" @click="deleteItem(item)" v-if="acl.deletesQuests">
                            <md-icon>delete</md-icon>
                        </md-button>
                    </md-table-cell>
                </md-table-row>
            </md-table>
        </div>
      </md-app-content>
    </md-app>
  </div>
</template>

<style lang="scss" scoped>
  .md-app {
    border: 1px solid rgba(#000, .12);
  }
  .md-dialog {
    max-width: 768px;
  }
  .actions-cell {
    text-align: right;
  }
  .md-select-content {
    z-index: 9999;
  }
</style>

<script>
import Vue from 'vue'
import Header from './Header.vue';
import Menu from './Menu.vue';
import firebase from 'firebase';
import {config} from '../helpers/apiConfig'
import {user} from '../helpers/user'
import axios from "axios";

import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: config.googleMapKey
  }
});

export default {
    name: 'Quests',
    components: {
        Header, Menu
    },
    data: () => ({
        menuVisible: false,
        radius: 1,
        radiusOptions: {
            fillColor: '#FF0000',
            strokeColor: '#FF0000'
        },
        center: {lat:-34.416452, lng:-58.589638},
        reportedCenter: {},
        loading: false,
        deleteConfirm: false,
        deleteItemId: null,
        quests: [],
        showDialog: false,
        form: {
            name: null,
            description: null,
            status: null,
            lat: null,
            lng: null,
            radius: null,
            questions: []
        },
        formForEdit: false,
        sending: false,
        lastUser: null,
        acl: {
            createsQuests: false,
            modifiesQuests: false,
            aprovesQuests: false,
            suspendsQuests: false,
            deletesQuests: false
        }
    }),
    mounted() {
        firebase.auth().onAuthStateChanged((liuser) => {
            if (liuser) {
                console.log('User logged in, go ahead...');
                var that = this;
                user.init(firebase.auth().currentUser, () => {
                    that.fetchData();
                });
            } else {
                this.$router.push('/auth')
                console.log('User not logged in!');
            }
        });
    },
    watch: {
        // call again the method if the route changes
        '$route': 'fetchData'
    },
    methods: {
        updateCenter(latLng) {
            this.reportedCenter = {
              lat: latLng.lat(),
              lng: latLng.lng(),
            };
            this.form.lat = this.reportedCenter.lat;
            this.form.lng = this.reportedCenter.lng;
        },
        sync () {
            this.center = this.reportedCenter
        },
        changeRadius (r) {
            this.radius = parseInt(r);
        },
        toggleMenu () {
            this.menuVisible = !this.menuVisible
        },
        fetchData () {
            this.quests = [];
            this.loading = true;
            this.acl = {
                createsQuests: user.hasPermission('createsQuests'),
                modifiesQuests: user.hasPermission('modifiesQuests'),
                aprovesQuests: user.hasPermission('aprovesQuests'),
                suspendsQuests: user.hasPermission('suspendsQuests'),
                deletesQuests: user.hasPermission('deletesQuests')
            }
            console.log('this.acl', this.acl);

            axios({ 
                "method": "GET", 
                "url": config.apiUrl + "/quest", 
                "headers": { "content-type": "application/json", "X-Auth": user.token } }
            ).then(result => {
                    console.log(result.data);
                    this.loading = false;
                    this.quests = result.data;
                }, error => {
                    console.error(error);
                    this.loading = false;
                    alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                }
            );
        },
        validateItem () {
            let validationError = false;
            if (!this.form.name) {
                validationError = true;
                alert('falta nombre');
            }

            if (!validationError) {
                if (this.formForEdit) {
                    axios({ 
                        "method": "PUT", 
                        "url": config.apiUrl + "/quest/" + this.editItemId, 
                        "data": this.form, 
                        "headers": { "content-type": "application/json", "X-Auth": user.token } }
                    ).then(result => {
                            console.log(result);
                            this.hideForm();
                            this.cleanForm();
                            this.fetchData();
                        }, error => {
                            console.error(error);
                            alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                        }
                    );
                } else {
                    axios({ 
                        "method": "POST", 
                        "url": config.apiUrl + "/quest", 
                        "data": this.form, 
                        "headers": { "content-type": "application/json", "X-Auth": user.token } }
                    ).then(result => {
                            console.log(result);
                            this.hideForm();
                            this.cleanForm();
                            this.fetchData();
                        }, error => {
                            console.error(error);
                            alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                        }
                    );
                }
            }
        },
        cleanForm () {
            this.form = {
                name: null,
                description: null,
                status: null,
                lat: null,
                lng: null,
                radius: null,
                questions: []
            }
            this.formForEdit = false;
            this.editItemId = null;
        },
        showForm () {
            this.showDialog = true;
        },
        hideForm () {
            this.showDialog = false;
        },
        cancelForm () {
            this.hideForm();
            this.cleanForm();
        },
        editItem (item) {
            console.log(item);
            this.form = {
                name: item.name,
                description: item.description,
                status: item.status,
                lat: parseFloat(item.lat),
                lng: parseFloat(item.lng),
                radius: item.radius,
                questions: item.questions
            }
            if (item.lat && item.lng) {
                this.center = {
                    lat: parseFloat(item.lat),
                    lng: parseFloat(item.lng)
                };
            }
            if (item.radius) {
                this.radius = parseInt(item.radius);
            }
            this.formForEdit = true;
            this.editItemId = item.id;
            this.showForm();
        },
        deleteItem (item) {
            this.deleteConfirm = true;
            this.deleteItemId = item.id;
        },
        onDeleteConfirm () {
            axios({ 
                "method": "DELETE", 
                "url": config.apiUrl + "/quest/" + this.deleteItemId, 
                "headers": { "content-type": "application/json", "X-Auth": user.token } }
            ).then(result => {
                    console.log(result);
                    this.fetchData();
                }, error => {
                    console.error(error);
                    alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                }
            );
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Quests.vue